import React, { useRef, useEffect, useState } from 'react';
// eslint-disable-next-line @typescript-eslint/prefer-ts-expect-error
// @ts-ignore
import Player from '@ad/ks-ad-alliance-animation-player';

interface PropTypes {
  className?: string;
  src: string;
  loop: boolean;
  time: number;
  fps: number;
  isPlaying: boolean;
  posterUrl?: string;
}
if (!window.cacheCanvas) {
  window.cacheCanvas = [];
}
// 入队列
function enQueueCanvas(canvas: HTMLCanvasElement) {
  window.cacheCanvas.push(canvas);
}
// 出队列
function deQueueCanvas(): HTMLCanvasElement {
  if (window.cacheCanvas.length === 0) {
    const canvas = document.createElement('canvas');

    return canvas;
  }
  // eslint-disable-next-line @typescript-eslint/prefer-ts-expect-error
  // @ts-ignore
  return window.cacheCanvas.shift();
}

export default (props: PropTypes) => {
  const canvasWrapRef = useRef<HTMLDivElement>(null);
  const [player, setPlayer] = useState<any>(null);
  const [currentCanvas, setCurrentCanvas] = useState<any>(null);
  // 假设场景是外部hover移入移出同时传给isPlaying
  // 当前canvas 缓存到队列。
  function clean() {
    player?.stop();
    player?.destroy();
    if (!currentCanvas) return;
    enQueueCanvas(currentCanvas);
    if (currentCanvas.parentNode) {
      currentCanvas.parentNode.removeChild(currentCanvas);
    }
    setCurrentCanvas(null);
  }
  useEffect(() => {
    if (props.isPlaying) {
      const canvas = deQueueCanvas();
      // 播放
      player?.stop();
      player?.destroy();
      const newPlayer = new Player({
        videoSrc: props.src,
        time: props.time,
        canvas,
        fps: props.fps,
        loop: props.loop,
        autoplay: props.isPlaying,
      });
      setPlayer(newPlayer);
      setCurrentCanvas(canvas);
      canvasWrapRef.current?.appendChild(canvas);
    } else {
      clean();
    }
  }, [props.isPlaying]);
  return (
    <div ref={canvasWrapRef} className={props.className}>
      {props.posterUrl && <img src={props.posterUrl} />}
    </div>
  );
};
